import React, { useCallback, useState, useRef, useEffect, useMemo } from "react";
import {
  Row,
  Col,
  Button,
  Tabs,
  Select,
  Input,
  Tooltip,
  Card,
  Spin,
  Dropdown,
  MenuProps,
  Popover,
  Menu,
  Modal
} from "antd";
import { AudioMutedOutlined, AudioOutlined, RobotOutlined, SettingOutlined } from "@ant-design/icons";
import Editor from "../../shared/components/Editor";
import RadAiAssistant from "../../shared/components/RadAiAssistant";
import "./reportDetail.scss";
import ManageTemplates from "../../shared/components/ManageTemplates";
import ReportTemplateService from "../../services/ReportTemplate/reportTemplate.service";
import { ReportTemplate } from "../../models/ReportTemplate/reportTemplate.model";
import ReportService, {
  resolveAiReportingAdminId,
} from "../../services/Report/report.service";
import AuthContainer from "../../store/container/AuthContainer";
import { AuthReducerProps } from "../../store/reducers/authReducer";
import Notification from "../../shared/components/Notification";
import { NotificationTypes } from "../../enums/notificationTypes";
import { Report } from "../../models/Report/report.model";
import { useHistory, useParams } from "react-router-dom";
import { AppRoutes } from "../../routes/routeConstants/appRoutes";
import { UserRoleEnum } from "../../enums/userRole.enum";
import { DownloadFileTypeEnum } from "../../enums/downloadFileType.enum";
import ApiRoutes from "../../routes/routeConstants/apiRoutes";

declare var MediaRecorder: any;
let socket: WebSocket | null = null;
const { TabPane } = Tabs;


interface ReportDetailProps extends AuthReducerProps {

};

function ReportDetail({userRole, user}: ReportDetailProps) {
  const [selectedTemplateId, setSelectedTemplateId] = useState<number | undefined>();

  const [activeManageTemplateId, setActiveManageTemplateId] = useState<number | undefined>();

  const [aiEdit, setAiEdit] = useState("");

  const [editorValue, setEditorValue] = useState<any>("");
  
  const editorInstanceRef = useRef<any>(null);

  const editorWrapperRef = useRef<HTMLDivElement>(null);

  const [voiceLoading, setVoiceLoading] = useState(false);

  const [isMuted, setIsMuted] = useState(true);

  const [activeTab, setActiveTab] = useState("insert");

  const [reportTemplateOptions, setReportTemplateOptions] = useState<any[]>([]);

  const [reportTemplates, setReportTemplates] = useState<ReportTemplate[]>([]);

  const [reports, setReports] = useState<Report[]>([]);

  const [activeReport, setActiveReport] = useState<Report>();

  const [sessionTimer, setSessionTimer] = useState(0); 

  const [timer, setTimer] = useState(0);

  const [totalTimer, setTotalTimer] = useState(0);

  const [isRunning, setIsRunning] = useState(false);

  const [isVoiceToTextEnabled, setVoiceToTextEnabled] = useState(false);
  
  const [isAiReportingEnabled, setAiReportingEnabled] = useState(false);

  const [aiCreditsUsed, setAiCreditsUsed] = useState(0);
  
  const [aiTotalCredits, setAiTotalCredits] = useState(0);
  
  const [isAiReportingAllowed, setAiReportingAllowed] = useState(false);
  
  const [isVoiceToTextAllowed, setVoiceToTextAllowed] = useState(false);

  const [textareaValue, setTextareaValue] = useState("");

  const [radAiOpen, setRadAiOpen] = useState(false);
  const [copilotModalOpen, setCopilotModalOpen] = useState(false);
  const [copilotDraft, setCopilotDraft] = useState("");
  const [copilotLoading, setCopilotLoading] = useState(false);
  const [copilotSaving, setCopilotSaving] = useState(false);

  // const sessionTimerRef = useRef(sessionTimer);

  const [aiReportLoading, setAiReportLoading] = useState(false);
  /** Until first streamed chunk: show Voxa prep overlay; hide once tokens arrive. */
  const [aiReportShowPrepLoader, setAiReportShowPrepLoader] = useState(false);

  const [downloadLoading, setDownloadLoading] = useState(false);

  const [saveLoading, setSaveLoading] = useState(false);

  const [reportTemplateName, setReportTemplateName] = useState<any>("");

  const [crudLoading, setCrudLoading] = useState(false);

  const [refreshReportTemplates, setRefreshReportTemplates] = useState(false);

  const [disableBtn, setDisableBtn] = useState(false);

  const [isDeepgram, setDeepgram] = useState(true);

  const [liveTranscript, setLiveTranscript] = useState("");

  const [baseValue, setBaseValue] = useState("");

    const sessionTimerRef = useRef(sessionTimer);
    const lastSyncedRef = useRef(0);
    const isSyncingRef = useRef(false);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);
    const prevIsDeepgramRef = useRef(isDeepgram);

  const params: any = useParams();

  // useEffect(() => {
  //   sessionTimerRef.current = sessionTimer;
  // }, [sessionTimer]);

  useEffect(() => {
    fetchReportTemplates();
  }, []);

  // isDeepgram defaults true; when feature flags load, Augnito users flip to false. Text they
  // typed in the Deepgram textarea lives in textareaValue only — migrate so the Augnito field
  // and generate validation see the same string.
  useEffect(() => {
    if (prevIsDeepgramRef.current && !isDeepgram) {
      setBaseValue((prev) => {
        if (prev.trim()) return prev;
        const migrated = textareaValue.trim();
        return migrated || prev;
      });
    }
    prevIsDeepgramRef.current = isDeepgram;
  }, [isDeepgram]);

  useEffect(() => {
    if(selectedTemplateId && reportTemplates.length > 0) {
      const selectedTemplate = reportTemplates.find((template) => template.id === selectedTemplateId);
      setEditorValue(selectedTemplate?.content);
    }
  }, [selectedTemplateId, reportTemplates]);

  useEffect(() => {
    setEditorValue('');
    setReportTemplateName('');
    setSelectedTemplateId(undefined);
    setActiveManageTemplateId(undefined);
  }, [activeTab]);

  useEffect(() => {
    const reportId = params.reportId;
    if(reportId !== 'new') {
      const numericReportId = parseInt(reportId, 10);
      ReportService.showDirectReport(numericReportId, (report: Report) => {
        setEditorValue(report?.content);
        setActiveReport(report);
      }, () => {}, () => {});
    }
    setVoiceAndAiFeature();
  }, [params]);

  const fetchReportTemplates = () => {
    ReportTemplateService.fetchReportTemplates(
        '',
        0,
        (reportTemplates: ReportTemplate[]) => {
          setReportTemplates(reportTemplates);
          setReportTemplateOptions(reportTemplates.map((template) => (
              {
                label: template?.name,
                value: template?.id
              }
          )));
        },
        () => {},
        () => {
        }
    );
  }

  const handleUpdateTemplate = () => {
    if(reportTemplateName.length === 0 || editorValue.length === 0) {
      Notification({
        message:
            "Report content/Report name should not be empty",
        type: NotificationTypes.ERROR,
      });
      return;
    }
    setCrudLoading(true);
    if (activeManageTemplateId) {
      const reportTemplate = new ReportTemplate();
      reportTemplate.id = activeManageTemplateId;
      reportTemplate.name = reportTemplateName;
      reportTemplate.content = editorValue;
      reportTemplate.scanTypeId = 16;

      ReportTemplateService.updateReportTemplate(
          reportTemplate,
          () => {
            setRefreshReportTemplates(true);
            fetchReportTemplates();
            setRefreshReportTemplates(false);
            setDisableBtn(true);
          },
          () => {},
          () => {
            setCrudLoading(false);
          }
      );
    } else {
      const reportTemplate = new ReportTemplate();
      reportTemplate.name = reportTemplateName;
      reportTemplate.content = editorValue;
      reportTemplate.scanTypeId = 16;
      ReportTemplateService.createReportTemplate(
          reportTemplate,
          () => {
            setRefreshReportTemplates(true);
            fetchReportTemplates();
            setRefreshReportTemplates(false);
            setDisableBtn(true);
          },
          () => {},
          () => {
            setCrudLoading(false);
          }
      );

    }
  }

  const handleSaveReport = () => {
    if(!editorValue || editorValue?.length <= 0) {
      Notification({
        message:
          "Report content should not be empty",
        type: NotificationTypes.ERROR,
      });
      return;
    }
    const report = Object.assign(new Report(), {
      ...activeReport,
      content: editorValue,
    });
    report.content = removeBgColor(report.content);
    setEditorValue(report.content);
    setActiveReport(Object.assign(new Report(), {
      ...activeReport,
      content: report.content
    }));
    setSaveLoading(true);
    setDisableBtn(true);
    ReportService.publishReport(report, () => {
    }, () => {}, () => {
      setSaveLoading(false);
    });
  };

  const handleExportReport = (type: DownloadFileTypeEnum) => {
    // @ts-ignore
    if (!activeReport || activeReport?.content.length === 0) {
      Notification({
        message: "You need to first publish the report before exporting!",
        type: NotificationTypes.ERROR,
      });
      return;
    }

    if(activeReport?.assignment?.caseDetail) {
      setDownloadLoading(true);
      ReportService.downloadReport(
        type,
        activeReport?.assignment?.caseDetail,
        false,
        activeReport?.id ?? 0,
        (reportUrl: string) => {
          window.open(reportUrl, "_blank");
        },
        () => {},
        () => {
          setDownloadLoading(false);
        }
      );
    }
  };

  const removeBgColor = (text: string): string => {
    return text.replace(
      /<span[^>]*style=["'][^"']*background-color:\s*yellow;?[^"']*["'][^>]*>(.*?)<\/span>/gi,
      "$1"
    );
  };

  const startSpeechRecognition = (
  ) => {
    // check if user breaches 5 minute threshold to use voice to text feature
    if (!isVoiceToTextAllowed) {
      Notification({
        message:
          "Voice to text feature time limit exceeded. Contact Support Team",
        type: NotificationTypes.ERROR,
      });
      return false;
    }
    let silenceTimeout: NodeJS.Timeout | null = null;
    setVoiceLoading(true);
    navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
      let previousTranscript = "";
      if (!("MediaRecorder" in window)) {
        return alert("Browser not supported");
      }

      const mediaRecorder = new MediaRecorder(stream, {
        mimeType: "audio/webm",
      });

      socket = new WebSocket(process.env.REACT_APP_VOICE_BASE_URL! + ApiRoutes.VOICE_TO_TEXT_ENABLE);

      socket.onopen = () => {
        setIsRunning(true);
        setIsMuted(false);
        Notification({
          message: "Speech detection activated!",
          type: NotificationTypes.SUCCESS,
        });
        mediaRecorder.addEventListener("dataavailable", async (event: any) => {
          if (event.data.size > 0 && socket!.readyState == 1) {
            socket!.send(event.data);
          }
        });
        mediaRecorder.start(1000);
        resetSilenceTimeout(); // Start silence timer
      };

      socket.onmessage = (message) => {
        const transcript = message.data;

        if (transcript) {
          // Append to CKEditor
          // const editorElement = document.querySelector(
          //     ".editor .ck-editor__editable"
          // );
          setTextareaValue((prevValue) => prevValue + " " + transcript);

          // if (document.activeElement === editorElement) {
          //   appendAtCursor(transcript);
          // } else if (document.activeElement === textareaElement) {
          //   // If the textarea is focused, update its value
          //   setTextareaValue((prevValue) => prevValue + transcript);
          // } else {
          //   // Default to CKEditor if nothing else is focused
          //   appendToEnd(transcript);
          // }
        }
        resetSilenceTimeout();
      };

      // Function to append text at the cursor
      const appendAtCursor = (transcript: string) => {
        const editorInstance = editorInstanceRef.current;
        if (editorInstance) {
          editorInstance.model.change((writer: any) => {
            const selection = editorInstance.model.document.selection;
            const insertPosition = selection.focus; // Cursor position
            writer.insertText(transcript + " ", insertPosition);
          });
        }
      };

      // Function to append text at the end of CKEditor
      const appendToEnd = (transcript: string) => {
        const editorInstance = editorInstanceRef.current;
        if (editorInstance) {
          const currentContent = editorInstance.getData(); // Get current content
          let updatedContent = currentContent;

          // Check if the last character is a line break or paragraph tag
          if (
            updatedContent.endsWith("</p>") ||
            updatedContent.endsWith("<br>")
          ) {
            // If it ends with a line break or paragraph, append the transcript within the same block
            updatedContent =
              updatedContent.replace(/<\/p>$/, "") + " " + transcript;
          } else {
            // Otherwise, append the text with a space and keep it within the same paragraph
            updatedContent = updatedContent + " " + transcript;
          }

          // Update the editor content
          editorInstance.setContent(updatedContent);
        }
      };

      socket.onclose = () => {
        mediaRecorder.stop();
        Notification({
          message: "Speech detection ended!",
          type: NotificationTypes.SUCCESS,
        });
        // Stop all tracks in the MediaStream to release the microphone
        if (stream) {
          stream.getTracks().forEach((track) => track.stop());
        }
        if (silenceTimeout) {
          clearTimeout(silenceTimeout);
          silenceTimeout = null;
        }
        setIsMuted(true);
        setIsRunning(false);
        setSessionTimer(0);
      };

      socket.onerror = (error) => {
        console.log({ event: "onerror", error });
      };
    });

    function resetSilenceTimeout() {
      if (silenceTimeout) clearTimeout(silenceTimeout);
      silenceTimeout = setTimeout(() => {
        // alert(timer)
        // alert(sessionTimer);
        stopSpeechRecognition();
        syncVoiceUsage();
        // setTimer(0);
        setSessionTimer(0);
      }, 30000);
    }
  };

    const startAugnitoSpeechRecognition = (
    ) => {
        if (!isVoiceToTextAllowed) {
            Notification({
                message: "Voice to text feature time limit exceeded. Contact Support Team",
                type: NotificationTypes.ERROR,
            });
            return;
        }

        let silenceTimeout: NodeJS.Timeout | null = null;
        setVoiceLoading(true);

        let audioContext: AudioContext;
        let processor: ScriptProcessorNode;
        let source: MediaStreamAudioSourceNode;
        let mediaStream: MediaStream;

        socket = new WebSocket(
            process.env.REACT_APP_VOICE_BASE_URL! +
            ApiRoutes.AUGNITO_VOICE_TO_TEXT_ENABLE
        );

        socket.binaryType = "arraybuffer";

        socket.onopen = async () => {
            setIsRunning(true);
            setIsMuted(false);

            Notification({
                message: "Speech detection activated!",
                type: NotificationTypes.SUCCESS,
            });

            // 🔑 Create AudioContext at 16kHz (MANDATORY)
            audioContext = new AudioContext({ sampleRate: 16000 });

            mediaStream = await navigator.mediaDevices.getUserMedia({ audio: true });

            source = audioContext.createMediaStreamSource(mediaStream);

            processor = audioContext.createScriptProcessor(4096, 1, 1);

            processor.onaudioprocess = (event) => {
                const input = event.inputBuffer.getChannelData(0);

                // Float32 → Int16 PCM
                const pcm16 = new Int16Array(input.length);
                for (let i = 0; i < input.length; i++) {
                    pcm16[i] = Math.max(-1, Math.min(1, input[i])) * 0x7fff;
                }

                // @ts-ignore
                if (socket.readyState === WebSocket.OPEN) {
                    // @ts-ignore
                    socket.send(pcm16.buffer);
                }

                // resetSilenceTimeout();
            };

            source.connect(processor);
            processor.connect(audioContext.destination);
            resetSilenceTimeout();
        };

        // socket.onmessage = (event) => {
        //     const data = JSON.parse(event.data);
        //
        //     if (data.text) {
        //         setTextareaValue((prev) => prev + " " + data.text);
        //     }
        // };

        socket.onmessage = (event) => {
            const data = JSON.parse(event.data);

            if (!data.text) return;

            if (data.type === "partial") {
                setLiveTranscript(data.text);
            }

            if (data.type === "final") {
                // setTextareaValue((prev) => prev + " " + data.text);
                setBaseValue((prev) => (prev + " " + data.text).trim());
                setTextareaValue((prev) =>
                    (prev + " " + data.text).replace(/\s+/g, " ").trim()
                );

                setLiveTranscript("");
            }
            resetSilenceTimeout();
        };


        socket.onclose = () => {
            Notification({
                message: "Speech detection ended!",
                type: NotificationTypes.SUCCESS,
            });

            processor?.disconnect();
            source?.disconnect();
            audioContext?.close();

            if (mediaStream) {
                mediaStream.getTracks().forEach((track) => track.stop());
            }

            if (silenceTimeout) {
                clearTimeout(silenceTimeout);
                silenceTimeout = null;
            }

            setIsMuted(true);
            setIsRunning(false);
            setSessionTimer(0);
        };

        socket.onerror = (error) => {
            console.error("WebSocket error:", error);
        };

        function resetSilenceTimeout() {
            if (silenceTimeout) clearTimeout(silenceTimeout);
            silenceTimeout = setTimeout(() => {
                // alert(timer)
                // alert(sessionTimer);
                stopSpeechRecognition();
                syncVoiceUsage();
                // setTimer(0);
                setSessionTimer(0);
            }, 30000);
        }
    };

    const syncVoiceUsage = (
        latestSeconds?: number
    ) => {
        if (isSyncingRef.current) return; // prevent duplicate

        const current =
            latestSeconds ??
            sessionTimerRef.current;

        const secondsToStore =
            current - lastSyncedRef.current;

        if (secondsToStore < 10) return;

        isSyncingRef.current = true;

        ReportService.storeVoiceToTextSessionData(
            userRole,
            user?.id,
            secondsToStore,
            activeReport?.assignment?.caseDetail?.id,
            () => {
                lastSyncedRef.current = current;
                isSyncingRef.current = false;
            },
            () => {
                isSyncingRef.current = false;
            },
            () => {
                isSyncingRef.current = false;
            }
        );
    };

    useEffect(() => {
        if (!isRunning) {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
            return;
        }

        // Prevent duplicate intervals
        if (intervalRef.current) return;

        intervalRef.current = setInterval(() => {
            setTimer((prev) => prev + 1);

            setSessionTimer((prev) => {
                const updated = prev + 1;

                const delta =
                    updated - lastSyncedRef.current;

                if (delta >= 10) {
                    syncVoiceUsage(updated);
                }

                return updated;
            });
        }, 1000);

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
    }, [isRunning]);


  const setVoiceAndAiFeature = () => {
    const featuresMap: Record<string, any> = {
      voice_to_text: {
        enabled: false,
        setter: setVoiceToTextEnabled,
        serviceCall: ReportService.getVoiceToTextInfo,
        updateState: (response: any) => {
          setTimer(response.data.used_credits);
          setTotalTimer(response.data.subscribed_credits);
          setSessionTimer(0);
          setVoiceToTextAllowed(response.data.allowed);
        },
      },
      ai_reporting: {
        enabled: false,
        setter: setAiReportingEnabled,
        serviceCall: ReportService.getAiReportingInfo,
        updateState: (response: any) => {
          setAiCreditsUsed(response.data.used_credits);
          setAiTotalCredits(response.data.subscribed_credits);
          setAiReportingAllowed(response.data.allowed);
        },
      },
    };

    const userFeatures =
      userRole === UserRoleEnum.ADMIN
        ? user?.adminFeatures : user?.doctorFeatures;

    let hasAugnito = false;

    userFeatures?.forEach((feature: any) => {
      if (featuresMap[feature.feature]) {
        featuresMap[feature.feature].enabled = true;
      }
      if (feature.feature === "augnito_stt") {
          hasAugnito = true;
      }
    });

    setDeepgram(!hasAugnito);

    Object.values(featuresMap).forEach(
      ({ enabled, setter, serviceCall, updateState }) => {
        if (enabled) {
          serviceCall(
            userRole,
            user?.id,
            (response: any) => {
              setter(true);
              updateState(response);
            },
            () => {},
            () => {}
          );
        }
      }
    );
  };

  const storeVoiceToTextSession = () => {
    ReportService.storeVoiceToTextSessionData(
      userRole,
      user?.id,
      sessionTimerRef.current,
      activeReport?.assignment?.caseDetail?.id,
      (response: any) => {
        setVoiceToTextEnabled(true);
        setTimer(response.data.used_credits);
        setTotalTimer(response.data.subscribed_credits);
        setIsMuted(true);
        setIsRunning(false);
        setSessionTimer(0);
        setVoiceToTextAllowed(response.data.allowed);
      },
      () => {},
      () => {}
    );
    setVoiceLoading(false);
  }

  const stopSpeechRecognition = () => {
    if (socket && socket.readyState !== 3) {
      socket.close();
      storeVoiceToTextSession();
      lastSyncedRef.current = 0
    }
  };

  const smartReporting = (
  ) => {
    if (!isAiReportingAllowed) {
      Notification({
        message:
          "AI reporting feature time limit exceeded. Contact Support Team",
        type: NotificationTypes.ERROR,
      });
      return false;
    }
    
  };

  const openCopilotModal = useCallback(() => {
    if (!isAiReportingAllowed) {
      Notification({
        message:
          "AI reporting feature time limit exceeded. Contact Support Team",
        type: NotificationTypes.ERROR,
      });
      return;
    }
    setCopilotModalOpen(true);
    setCopilotLoading(true);
    ReportService.fetchAiReportingCopilot(
      userRole,
      (prompt) => {
        setCopilotDraft(prompt);
        setCopilotLoading(false);
      },
      (msg) => {
        Notification({ message: msg, type: NotificationTypes.ERROR });
        setCopilotLoading(false);
      }
    );
  }, [isAiReportingAllowed, userRole]);

  const saveCopilotDraft = useCallback(() => {
    setCopilotSaving(true);
    ReportService.saveAiReportingCopilot(
      userRole,
      copilotDraft,
      () => {
        setCopilotSaving(false);
        setCopilotModalOpen(false);
        Notification({
          message:
            "Your copilot instructions were saved. They apply to your future Smart Reports.",
          type: NotificationTypes.SUCCESS,
        });
      },
      (msg) => {
        setCopilotSaving(false);
        Notification({ message: msg, type: NotificationTypes.ERROR });
      }
    );
  }, [userRole, copilotDraft]);

  const storeAiReportingSession = () => {
    ReportService.storeAiReportingSessionData(
      userRole,
      user?.id,
      1,
      activeReport?.assignment?.caseDetail?.id,
      (response: any) => {
        setAiCreditsUsed(response.data.used_credits);
        setAiTotalCredits(response.data.subscribed_credits);
        setAiReportingAllowed(response.data.allowed);
      },
      () => {},
      () => {}
    );
    setVoiceLoading(false);
  }

  const generateGeminiReport = async (
    textContent: string,
    editorValue: any
  ) => {
    try {
      stopSpeechRecognition();
      if (!isAiReportingAllowed) {
        Notification({
          message:
            "Voice to text feature time limit exceeded. Contact Support Team",
          type: NotificationTypes.ERROR,
        });
        return false;
      }
      const report = Object.assign(new Report(), {
        ...activeReport,
        content: editorValue
      });
      if (report) {
        setAiReportLoading(true);
        setAiReportShowPrepLoader(true);
        const editorInstance = editorInstanceRef.current;
        // Live editor HTML = the mandatory report template / current report. We
        // merge the findings into it (refine-style) so the layout is preserved.
        const liveEditorHtml =
          (typeof editorInstance?.getContent === "function"
            ? editorInstance.getContent()
            : report.content) || report.content || "";
        editorInstance.mode.set('readonly'); // Disable editor
        const editorContent = liveEditorHtml;
        editorInstance.setContent(".");
        const cd = activeReport?.assignment?.caseDetail;
        ReportService.generateGeminiReport(
          report,
          liveEditorHtml,
          textContent,
          [],
          (generatedText: string) => {
            generatedText = generatedText.replace(/```html|```/g, "").trim();
            editorInstance.setContent(generatedText);
            editorInstance.mode.set('design');
            storeAiReportingSession();
            setAiReportLoading(false);
            setAiReportShowPrepLoader(false);
            setDisableBtn(true);
          },
          (errorMessage?: string) => {
            editorInstance.mode.set('design'); // Enable editor
            Notification({
              message: errorMessage || "Smart Report generation failed",
              type: NotificationTypes.ERROR,
            });
            editorInstance.setContent(editorContent);
          },
          () => {
            const ed = editorInstanceRef.current;
            if (ed && typeof ed.mode?.set === "function") {
              ed.mode.set("design");
            }
            setAiReportLoading(false);
            setAiReportShowPrepLoader(false);
            setTextareaValue("");
          },
          {
            adminId: resolveAiReportingAdminId(userRole, user),
            useReportTemplate: true,
            userRole,
            caseDetail: cd,
            onStreamChunk: (acc: string) => {
              setAiReportShowPrepLoader(false);
              editorInstance.setContent(acc);
              if (typeof editorInstance.mode?.set === "function") {
                editorInstance.mode.set("readonly");
              }
            },
          }
        );
      }
    } catch (error) {
      console.error("Gemini AI reporting error");
    }
  };


  const getAiFindingsText = () => {
    const deepgramText = textareaValue.trim();
    const augnitoText = `${baseValue}${liveTranscript || ""}`.trim();
    if (isDeepgram) {
      return deepgramText || augnitoText;
    }
    return augnitoText || deepgramText;
  };

  const handleGenerateReport = () => {
    const findings = getAiFindingsText();
    if (!findings) {
      alert(
        "Please enter key findings or observations for generating report."
      );
    } else {
      const width = window.innerWidth;
      if(width <= 768 && editorWrapperRef?.current) {
        editorWrapperRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
      generateGeminiReport(findings, editorValue).then((r: any) => {
      });
    }
  };

    const formatTime = (seconds: number) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
    };

  const items: any = [
    {
      key: '1',
      label: (
        <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com">
          1st menu item
        </a>
      ),
    },
    {
      key: '2',
      label: (
        <a target="_blank" rel="noopener noreferrer" href="https://www.aliyun.com">
          2nd menu item
        </a>
      ),
    }
  ];

  return (
    <div className="report-detail">
      <Row gutter={0}>
        <Col span={6} xs={24} sm={24} md={6} lg={6} xl={6} className="report-detail__sidebar">
          <div className="report-detail__sidebar-label">Templates</div>
          <Card className="report-detail__card report-detail__templates-card" bordered={false}>
            <Tabs defaultActiveKey="insert" className="report-detail__tabs" onChange={setActiveTab}>
              <TabPane tab="Insert Template" key="insert" className="report-detail__tab-pane">
                <Select
                  allowClear
                  className="report-detail__template-select"
                  placeholder="Select template to insert (optional for AI)"
                  options={reportTemplateOptions}
                  value={selectedTemplateId}
                  onChange={(v) => setSelectedTemplateId(v)}
                  style={{ width: "100%" }}
                  showSearch
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                      ((option?.label as string) ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                  }
                />
                {/* <Button
                  className="report-detail__insert-btn"
                  type="default"
                  block
                  style={{ marginTop: 20 }}
                >
                  Insert Template
                </Button> */}
              </TabPane>
              <TabPane tab="Manage Templates" key="manage" className="report-detail__tab-pane" >
                <ManageTemplates
                  editorValue={editorValue}
                  setReportTemplateName={setReportTemplateName}
                  setEditorValue={setEditorValue}
                  activeManageTemplateId={activeManageTemplateId}
                  setActiveManageTemplateId={setActiveManageTemplateId}
                  refreshReportTemplates={refreshReportTemplates}
                />
              </TabPane>
            </Tabs>
          </Card>
          {
            activeTab === "insert" && (
              <>
                <div className="report-detail__ai-label">Edit using AI</div>
                <div className="Credit Balance" style={{ marginBottom: 8, fontSize: 12, opacity: 0.85 }}>
                  Template is optional: choose one to merge findings into that layout, or leave cleared for a full report from findings only.
                </div>
                <div className="Credit Balance">
                  {`Credit Used: ${aiCreditsUsed} / ${aiTotalCredits}`}
                </div>
                <div className="Credit Balance">
                  {`Minutes Used: ${formatTime(timer)} / ${formatTime(totalTimer)}`}
                </div>
                <Card className="report-detail__card report-detail__ai-card" bordered={false}>
                    {/*<Input.TextArea*/}
                    {/*    className="report-detail__ai-textarea"*/}
                    {/*    rows={13}*/}
                    {/*    placeholder="Type changes here or click on the mic to record your changes"*/}
                    {/*    value={baseValue + (liveTranscript ? liveTranscript : "")} // append live without extra space*/}
                    {/*    onChange={(e) => {*/}
                    {/*        setBaseValue(e.target.value); // user typed text*/}
                    {/*        setTextareaValue(e.target.value); // if you still need it elsewhere*/}
                    {/*    }}*/}
                    {/*    style={{*/}
                    {/*        color: liveTranscript ? "#999" : "inherit"*/}
                    {/*    }}*/}
                    {/*/>*/}

                    {isDeepgram ? (
                        <>
                        <Input.TextArea
                            className="report-detail__ai-textarea"
                            rows={13}
                            placeholder="Type changes here or click on the mic to record your changes"
                            value={textareaValue}
                            onChange={e => setTextareaValue(e.target.value)}
                        />
                      <div className="report-detail__ai-actions">
                        <Tooltip title="Record changes">
                          <Button
                            shape="circle"
                            onClick={() => {
                              if (voiceLoading) {
                                stopSpeechRecognition();
                              } else {
                                startSpeechRecognition();
                                smartReporting();
                              }
                            }}
                            icon={isMuted ? <AudioMutedOutlined/> : <AudioOutlined />}
                            className="report-detail__ai-mic-btn"
                          />
                        </Tooltip>
                        <Tooltip title="Customize your copilot">
                          <Button
                            shape="circle"
                            icon={<SettingOutlined />}
                            loading={copilotLoading}
                            onClick={openCopilotModal}
                            disabled={disableBtn}
                            className="report-detail__ai-mic-btn"
                            style={{ marginLeft: 8 }}
                          />
                        </Tooltip>
                        <Button
                          type="primary"
                          className="report-detail__ai-update-btn"
                          block
                          style={{ marginLeft: 8 }}
                          onClick={handleGenerateReport}
                        >
                          Generate Report
                        </Button>
                      </div>
                        </>
                  ) : null}

                    {!isDeepgram ? (
                        <>
                            <Input.TextArea
                                className="report-detail__ai-textarea"
                                rows={13}
                                placeholder="Type changes here or click on the mic to record your changes"
                                value={baseValue + (liveTranscript ? liveTranscript : "")} // append live without extra space
                                onChange={(e) => {
                                    const v = e.target.value;
                                    setBaseValue(v);
                                    setTextareaValue(v);
                                    if (liveTranscript) setLiveTranscript("");
                                }}
                                style={{
                                    color: liveTranscript ? "#999" : "inherit"
                                }}
                            />
                        <div className="report-detail__ai-actions">
                            <Tooltip title="Record changes">
                                <Button
                                    shape="circle"
                                    onClick={() => {
                                        if (voiceLoading) {
                                            stopSpeechRecognition();
                                        } else {
                                            startAugnitoSpeechRecognition();
                                            smartReporting();
                                        }
                                    }}
                                    icon={isMuted ? <AudioMutedOutlined/> : <AudioOutlined />}
                                    className="report-detail__ai-mic-btn"
                                />
                            </Tooltip>
                            <Tooltip title="Customize your copilot">
                              <Button
                                shape="circle"
                                icon={<SettingOutlined />}
                                loading={copilotLoading}
                                onClick={openCopilotModal}
                                disabled={disableBtn}
                                className="report-detail__ai-mic-btn"
                                style={{ marginLeft: 8 }}
                              />
                            </Tooltip>
                            <Button
                                type="primary"
                                className="report-detail__ai-update-btn"
                                block
                                style={{ marginLeft: 8 }}
                                onClick={handleGenerateReport}
                            >
                                Generate Report
                            </Button>
                        </div>
                        </>
                    ) : null}
                </Card>
              </>
            )
          }
        </Col>
        <Col span={18} xs={24} sm={24} md={18} lg={18} xl={18} className="report-detail__main">
          <div className="report-detail__main-header">
            <div className="report-detail__main-title">{ activeTab === "insert" ? "Report" : "Manage Templates" }</div>
            <div className="report-detail__main-actions">
              {
                activeTab === 'insert' &&
                <>
                  <Popover
                    destroyTooltipOnHide
                    overlayClassName="admin-cases__assignment-popover"
                    placement="bottomLeft"
                    content={
                      <div>
                        <Menu mode="vertical" className="border-none">
                          <Menu.Item
                            className="navbar-item m-0"
                            key="with_letterhead"
                            onClick={() => {
                              handleExportReport(DownloadFileTypeEnum.PDF);
                            }}
                          >
                            Export as PDF
                          </Menu.Item>
                        
                          <Menu.Item
                            className="navbar-item m-0"
                            key="as_word"
                            onClick={() => {
                              handleExportReport(DownloadFileTypeEnum.WORD);
                            }}
                          >
                            Export  as Word
                          </Menu.Item>
                        </Menu>
                      </div>
                    }
                    title="Export Report"
                    trigger="click"
                    >
                      <Button
                        className="report-detail__share-btn" 
                        loading={downloadLoading} 
                        disabled={downloadLoading}
                        >
                        Export Report
                      </Button>
                  </Popover>

                  <Button className="report-detail__export-btn" 
                    loading={saveLoading}
                    // disabled={disableBtn}
                    type="primary"
                    onClick={handleSaveReport}>
                      Save and Publish Report
                  </Button>
                </>
              }
              {
                activeTab === 'manage' &&
                <>
                  <Button className="report-detail__export-btn" type="primary" onClick={handleUpdateTemplate} loading={crudLoading} disabled={disableBtn}>
                    {
                      activeManageTemplateId ? "Update Template": "Create Template"
                    }
                  </Button>
                </>
              }
            </div>
          </div>
          <div className="report-detail__editor-wrapper" ref={editorWrapperRef}>
            {
                activeTab === "manage" && (
                    <div style={{ marginBottom: "10px"}}>
                      <Row>
                        <Col span={8} sm={24} xs={24} md={12} lg={8} xl={8}>
                          <b><label>Report template name</label></b>
                          <Input
                            id="report-template-name"
                            placeholder="Enter template name"
                            value={reportTemplateName}
                            onChange={(e) => setReportTemplateName(e.target.value)}
                            allowClear
                            style={{ marginTop: "4px" }}
                          />
                        </Col>
                      </Row>
                    </div>
                )
            }
            <Editor
              value={editorValue}
              onChangeHandler={(data) => {
                setEditorValue(data);
                setDisableBtn(false);
              }}
              editorInstanceRef={editorInstanceRef}
              readOnly={aiReportLoading}
              aiReportStreaming={
                aiReportLoading && !aiReportShowPrepLoader
              }
            />
            {aiReportLoading && aiReportShowPrepLoader && (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "rgba(255,255,255,0.6)",
                  zIndex: 10,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  pointerEvents: "none", // Allows click-through for readOnly editor
                }}
              >
                <Spin
                  size="large"
                  style={{ color: "#1747E9" }}
                  tip="Voxa is preparing your radiology report"
                />
              </div>
            )}
          </div>
        </Col>
      </Row>

      {!radAiOpen && (
        <Tooltip title="Chat with RadAI Assistant" placement="left">
          <button
            type="button"
            className="radai-fab"
            aria-label="RadAI Assistant"
            onClick={() => setRadAiOpen(true)}
          >
            <RobotOutlined className="radai-fab__icon" />
          </button>
        </Tooltip>
      )}

      <RadAiAssistant
        visible={radAiOpen}
        onClose={() => setRadAiOpen(false)}
        userRole={userRole}
        caseDetail={activeReport?.assignment?.caseDetail}
        getReportContent={() =>
          ((editorInstanceRef.current?.getContent?.() as string) ||
            editorValue ||
            "")}
        onInsert={(html: string) => {
          const inst = editorInstanceRef.current;
          if (inst && typeof inst.insertContent === "function") {
            inst.insertContent(html);
            if (typeof inst.getContent === "function") {
              setEditorValue(inst.getContent());
            }
          } else {
            setEditorValue((editorValue || "") + html);
          }
        }}
      />

      <Modal
        title="Customize your copilot"
        visible={copilotModalOpen}
        onCancel={() => !copilotSaving && setCopilotModalOpen(false)}
        onOk={saveCopilotDraft}
        okText="Save"
        confirmLoading={copilotSaving}
        destroyOnClose
        width={560}
        maskClosable={!copilotSaving}
        okButtonProps={{ disabled: copilotLoading }}
      >
        <p style={{ color: "#595959", marginBottom: 12 }}>
          How do you want Voxa to generate your reports? Describe formatting,
          structure, tone, or standing rules. Saved instructions apply only to
          your account and take highest priority when they conflict with generic
          guidance.
        </p>
        <Input.TextArea
          rows={10}
          maxLength={200000}
          value={copilotDraft}
          onChange={(e) => setCopilotDraft(e.target.value)}
          placeholder='e.g. "Number all impression lines; keep Findings as short paragraphs; prefer British spelling."'
          disabled={copilotLoading || copilotSaving}
        />
        {copilotLoading ? (
          <div style={{ textAlign: "center", padding: 16 }}>
            <Spin />
          </div>
        ) : null}
      </Modal>
    </div>
  );
}

export default AuthContainer(ReportDetail); 